export default __webpack_public_path__ + "static/media/Banner_image_Werfkelder.1a9f3340.jpg";